import { FormikValues } from 'formik';
import { ITaskForm } from '../../../../state/ui/forms';
import { IRoute } from '../../../../state/ui/planning/routes';
import { TAttributeDictionary } from '../../../../features/Attributes/types';

type TDates = { from: string; to: string };
export interface IEditTaskDialogFormValues {
    data: ITaskForm;
    attributes: TAttributeDictionary;
}
export interface ITaskModificationDialogParams {
    taskId?: number;
    routeAssigned?: boolean | null;
    dates?: TDates;
    route?: IRoute | null;
    mode: 'add' | 'edit' | 'copy';
    onSuccess: () => void;
    handleAddLocation: (values: FormikValues) => void;
}

export enum EUpdateTaskErrorCode {
    EXISTING_RFID_ON_DATE = 'EXISTING_RFID_ON_DATE',
    TOO_MANY_ROUTES = 'TOO_MANY_ROUTES',
}

export interface IUpdateTaskError {
    status: number;
    responseJSON: {
        entity: {
            errorCode: EUpdateTaskErrorCode;
            errorMessage: string;
        };
    };
}
